import template from './smartlock.modal.html';

/* @ngInject */
function PadlockPanelModalController(
  $uibModalInstance,
  lockModel
) {
  this.usageTypes = [
    { type: 'single', description: 'A single use code for allowing one-time access' },
    { type: 'multi', description: 'A reusable code for allowing regular access' }
    // Emergency codes are only created once automatically when the padlock is created
  ];
  this.lockModel = lockModel;
  this.codeRequest = {
    equipmentId: this.lockModel.eq.id,
    phone: '', //  Instantiated or it wont be included in submission (but why?) -Bin
    type: this.usageTypes[0].type // Default: single
  };
  this.cancel = () => $uibModalInstance.dismiss();
  this.confirm = () => $uibModalInstance.close(this.codeRequest);
}


export default {
  template,
  controller: PadlockPanelModalController,
  controllerAs: '$modal'
};
